<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <page>
    <template v-slot:content>
      <transition name="slidedown">
        <div v-if="crumbsVisible" class="page-crumbs">
          <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
              <router-link
                :key="`crumb_${crumb.name}`"
                v-for="crumb in $route.meta.crumbs"
                :to="{ name: crumb.name }"
                tag="li"
              >
                <a
                  ><span class="link">{{ crumb.label }}</span></a
                >
              </router-link>
              <li v-if="article" class="is-active">
                <a href="#" aria-current="page">{{ getArticleTitle() }}</a>
              </li>
            </ul>
          </nav>
        </div>
      </transition>
      <div class="page">
        <section class="page-section" v-if="!article">
          Loading...
        </section>
        <section class="page-section" v-if="article">
          <div class="section-heading">
            <div class="title is-size-2 is-bold">{{ article.title }}</div>
          </div>
          <div class="page-section-content" style="font-size: 1.5rem;">
            <div
              style="display: flex; justify-content: center; flex-direction: column; text-align: center;"
            >
              <div style="flex-grow: 0; font-size: 3rem;">
                {{ $t("Today we're") }}
                {{ todayOpen ? $t("open") : $t("closed") }}
              </div>
              <div
                v-if="todayOpen"
                style="flex-grow: 0; font-size: 2rem; font-weight: bold;"
              >
                {{ `${openingHours.from} - ${openingHours.to}` }}
              </div>
            </div>
          </div>
          <br />
          <div
            v-if="article"
            class="page-section-content article-content"
            style="font-size: 1.5rem;"
          >
            <p v-html="getContentByLanguage()"></p>
          </div>
        </section>
      </div>
    </template>
  </page>
</template>

<script>
import Page from "./../common/page";
import Article from "./../../services/article";
import { format } from "timeago.js";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      article: null,
      prevRoute: null,
      crumbsVisible: false
    };
  },
  methods: {
    timeAgo(date) {
      return format(date);
    },
    ...mapActions({ loadHours: "openingHours/load" }),
    getContentByLanguage() {
      const langCode = this.$i18n.locale;
      for (let trnslation of this.article.ArticleTranslations) {
        if (trnslation.Language.two_letter_code === langCode) {
          return trnslation.content;
        }
      }
      return this.article.ArticleTranslations[0].content;
    },
    getArticleTitle() {
      const langCode = this.$i18n.locale;
      for (let trnslation of this.article.ArticleTranslations) {
        if (trnslation.Language.two_letter_code === langCode) {
          return trnslation.title;
        }
      }
      return this.article.ArticleTranslations[0].title;
    }
  },
  computed: {
    ...mapGetters({
      todayOpen: "openingHours/open",
      openingHours: "openingHours/hours"
    })
  },
  components: {
    Page
  },
  metaInfo: {
    title: "Article"
  },
  async mounted() {
    this.article = await Article.get("visit-us");
    this.crumbsVisible = true;
  }
};
</script>
<style lang="scss" scoped>
@import "./../../styles/index";
@import "./page-scoped";

.link {
  color: $color-text;
  cursor: pointer;

  &:hover {
    @include link-underline(#e1e1e1, $color-text, $color-selection);
  }
}

.bottom-links {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
</style>
<style lang="scss">
@import "./article";
</style>
